import React, { ReactNode } from 'react'
import { Button } from '@ui'
import { useUsageTypes } from '@ui/selects/UsageTypeSelect'
import { IUsageType } from '@api'

interface UpdateUsageSectionProps {
  text: string
  filter: (usageType: IUsageType) => boolean
  updateSpaceUsage: (usageType: IUsageType) => void
}

export default function UpdateUsageSection({
  text,
  updateSpaceUsage,
  filter,
}: UpdateUsageSectionProps) {
  const usageTypes = useUsageTypes()

  const items: ReactNode[] = usageTypes.filter(filter).map((usageType) => (
    <div key={usageType.id} style={{ margin: '5px 0' }}>
      <Button
        fill
        minimal
        ghost
        text={usageType.displayName}
        onClick={() => updateSpaceUsage(usageType)}
      />
    </div>
  ))
  return (
    <div style={{ marginTop: -10, height: 277, width: 280 }}>
      <p>{text}</p>
      {items.length ? (
        items
      ) : (
        <div style={{ margin: '5px 0' }}>
          <Button fill minimal ghost text="Loading" loading={true} onClick={() => null} />
        </div>
      )}
    </div>
  )
}
